import React, {useEffect, useState} from 'react';
import {Offcanvas} from 'react-bootstrap';
import {Link} from 'react-router-dom';
import {useTranslate} from '../../../hooks/LanguageProvider';
import '../../../assets/css/account-drawer.css';

type Account = {id_user:number;username_user:string;nom_user?:string;prenom_user?:string;email_user?:string;company?:string;nom_role?:string;date_last_connection?:string;permissions:number[]};
const tools = [
  {to:'/notifications',label:'Notifications',icon:'bell',permission:32},
  {to:'/Connection',label:'connection_log',icon:'history',permission:20},
  {to:'/Users',label:'Users',icon:'users',permission:25},
  {to:'/role',label:'Roles',icon:'user-shield',permission:2},
  {to:'/Help',label:'Help',icon:'life-ring',permission:33},
];
export default function AccountDrawer({show,onHide,image,logout}:{show:boolean;onHide:()=>void;image:string;logout:React.ReactNode}) {
  const {translate:tr,lang}=useTranslate();
  const [account,setAccount]=useState<Account|null>(null);
  const [failed,setFailed]=useState(false),[loading,setLoading]=useState(false),[retry,setRetry]=useState(0),[imageFailed,setImageFailed]=useState(false);
  useEffect(()=>{setImageFailed(false);},[image]);
  useEffect(()=>{
    if(!show)return;
    const controller=new AbortController();setLoading(true);setFailed(false);setAccount(null);
    fetch(`${process.env.REACT_APP_BACKEND_URL||''}/api/account-summary`,{credentials:'include',signal:controller.signal})
      .then(async response=>{if(!response.ok)throw new Error();return response.json();})
      .then(value=>{if(!controller.signal.aborted)setAccount(value);})
      .catch(()=>{if(!controller.signal.aborted)setFailed(true);})
      .finally(()=>{if(!controller.signal.aborted)setLoading(false);});
    return()=>controller.abort();
  },[show,retry]);
  const name=account?[account.nom_user,account.prenom_user].filter(Boolean).join(' ').trim():'';
  const lastLogin=account?.date_last_connection?new Date(account.date_last_connection):null;
  return <Offcanvas id="account-drawer" className="account-drawer" show={show} placement="end" onHide={onHide} aria-labelledby="account-drawer-title">
    <span id="account-drawer-title" className="visually-hidden">{tr('My account')}</span>
    <button type="button" className="account-drawer-close" aria-label={tr('Close')} onClick={onHide}><i className="fas fa-times" aria-hidden="true"/></button>
    <Offcanvas.Body aria-busy={loading}>
      {loading&&<p role="status">{tr('Loading')}</p>}
      {failed&&<div role="alert"><p>{tr('Account details unavailable')}</p><button className="btn btn-outline-secondary" onClick={()=>setRetry(value=>value+1)}>{tr('Refresh')}</button></div>}
      {account&&<>
        <div className="account-drawer-original text-center">
          <div className="profile-detail text-center">
            <img src="/asset/images/page-img/profile-bg.jpg" alt="GeoTracking" className="img-fluid account-drawer-cover-image"/>
            <div className="rounded profile-img account-drawer-logo-card">
              {image&&!imageFailed?<img src={image} className="account-drawer-logo-image" alt={tr('Profile')} onError={()=>setImageFailed(true)}/>:<span className="account-drawer-avatar" aria-hidden="true">{(name||account.username_user).slice(0,1).toUpperCase()}</span>}
              <span className="account-drawer-role">{account.nom_role || tr('Not available')}</span>
            </div>
          </div>
          <div className="account-drawer-identity">
            <div className="account-drawer-session">
            <div className="account-drawer-person">
            <i className="las la-user" aria-hidden="true"/>
            <div>
            <p className="account-drawer-widget-title">{account.username_user}</p>
            {name&&name.toLocaleLowerCase()!==account.username_user.toLocaleLowerCase()&&<p className="account-drawer-widget-value">{name}</p>}
            </div>
            </div>
            <div className="account-drawer-connection"><i className="fas fa-history" aria-hidden="true"/><div><p className="account-drawer-widget-title">{tr('Last login')}</p><p className="account-drawer-widget-value">{lastLogin&&!Number.isNaN(lastLogin.getTime())?lastLogin.toLocaleString(lang):tr('Not available')}</p></div></div>
            </div>
          </div>
        </div>
        <div className="account-drawer-content">
        <h6 className="mt-4">{tr('My tools')}</h6>
        <p className="account-drawer-hint">{tr('Account tools permissions help')}</p>
        <nav aria-label={tr('My tools')} className="account-drawer-links">
          {Number(account.id_user)===1&&<Link to="/security" onClick={onHide}><i className="fas fa-shield-alt" aria-hidden="true"/><span>{tr('Security center')}</span><i className="fas fa-chevron-right" aria-hidden="true"/></Link>}
          {tools.filter(tool=>account.permissions.includes(tool.permission)).map(tool=><Link key={tool.to} to={tool.to} onClick={onHide}><i className={`fas fa-${tool.icon}`} aria-hidden="true"/><span>{tr(tool.label)}</span><i className="fas fa-chevron-right" aria-hidden="true"/></Link>)}
          {!tools.some(tool=>account.permissions.includes(tool.permission))&&Number(account.id_user)!==1&&<p>{tr('No additional tools')}</p>}
        </nav>
        </div>
      </>}
    </Offcanvas.Body>
    <div className="account-drawer-footer">
      <div className="account-drawer-original-actions d-flex align-items-center justify-content-center">
      <Link className="btn btn-outline-secondary" to="/profile" onClick={onHide}><i className="las la-user" aria-hidden="true"/> {tr('Profile')}</Link>
      <ul className="list-unstyled mb-0">{logout}</ul>
      </div>
    </div>
  </Offcanvas>;
}
